<template>
    <div class="lam-button-group-field">
        <form-input
            type="float"
            :name="name"
            :value="value[name]"
            :required="required"
            :editable="editable"
            class="uk-width-1-1"
            @input="$emit('input', $event, name)"
        >
            <template v-slot:read_only>
                <slot name="read_only">
                    <label class="uk-form-label uk-background-disabled">
                        {{ $numeral(value[name]).format("0,0.00") }}
                        <span v-if="value[unitName]==='AC'">Acres</span>
                        <span v-if="value[unitName]==='SM'">M<sup>2</sup></span>
                        <span v-if="value[unitName]==='SF'">Ft<sup>2</sup></span>
                    </label>
                </slot>
            </template>
        </form-input>
        <div v-if="editable" class="uk-button-group" data-uk-button-radio>
            <base-button
                :class="{'uk-active': value[unitName]==='SF'}"
                @click.prevent="$emit('input', 'SF', unitName)"
            >
                Ft<sup>2</sup>
            </base-button>
            <base-button
                :class="{'uk-active': value[unitName]==='SM'}"
                @click.prevent="$emit('input', 'SM', unitName)"
            >
                M<sup>2</sup>
            </base-button>
            <base-button
                :class="{'uk-active': value[unitName]==='AC'}"
                @click.prevent="$emit('input', 'AC', unitName)"
            >
                AC
            </base-button>
        </div>
    </div>
</template>

<script type="text/javascript">
import FormInput from "./FormInput"
import BaseButton from "./BaseButton"

export default {
    components: {
        FormInput,
        BaseButton
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        unitName: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: null
        },
        editable: {
            type: Boolean,
            default: true
        },
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>
